import { CallMessage, Message, MessageType } from "@/store/chats/types";

export const getIsMessageCallType = (
  message: Message,
): message is CallMessage => {
  return message.type === MessageType.Call;
};
